import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getFubspot = api((id) =>
    query(
        gql`
            query GetFubspot($id: String!) {
                getFubspot(id: $id)
            }
        `,
        { id },
        { returns: "getFubspot" }
    )
)
